import { apiDeleteCameraSensorHistory, apiListAnalyzedCameraSensorHistories, apiListCameraImagePastFlood, apiListCameraSensorHistories } from 'apis/SensorApi';
import { downloadData, remove, uploadData } from 'aws-amplify/storage';
import FanLoadingIcon from "components/FanLoadingIcon";
import Pagination from "components/Pagination";
import { ITEM_NUM_PER_PAGE } from 'constants/config';
import { DIALOG_ERROR_GENERAL_ERROR_MESSAGE, DIALOG_MESSAGE_DELETE_CAMERA_IMAGE_FILE_SUCCESSFULLY, DIALOG_MESSAGE_DELETE_CAMERA_PAST_FLOOD_FILE_SUCCESSFULLY, DIALOG_MESSAGE_UPLOAD_FILE_SUCCESSFULLY } from "constants/message";
import { useDialog } from "context/DialogContext";
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { UNDEFINED_TEXT } from 'utils/constanst';
import { convertMomentFormat, convertMomentToFileName, sortFileByName } from 'utils/function';
import CameraTrafficVolumeChart from './CameraTrafficVolumeChart';
import SensorCameraImage from "./SensorCameraImage";
import './SensorDetailViewCamera.css';
import SensorHistoryList from './SensorHistoryList';

const propTypes = {
  sensor: PropTypes.object,
  onButtonMapClick: PropTypes.func,
  onBack: PropTypes.func
};

const HISTORY_PAGE_SIZE = 150
const ANALYZED_PAGE_SIZE = 100

const DISPLAY_TYPE = {
  CAMERA_IMAGE: 'camera',
  PAST_FLOODS_IMAGE: 'past-floods',
  CAMERA_TRAFFIC_VOLUME_CHART: 'chart'
}

const PREFIX_IMAGE = {
  [DISPLAY_TYPE.CAMERA_IMAGE]: '',
  [DISPLAY_TYPE.PAST_FLOODS_IMAGE]: 'past-floods'
}
export default function SensorDetailViewCamera(props) {
  const { sensor, targetGroup } = props
  const { state } = useLocation()
  const [curHistoriesPage, setCurHistoriesPage] = useState(1);
  const [curAnalyzedPage, setCurAnalyzedPage] = useState(1);
  const [displayType, setDisplayType] = useState(state?.displayType || DISPLAY_TYPE.CAMERA_IMAGE);
  const [histories, setHistories] = useState([])
  const [analyzedHistories, setAnalyzedHistoris] = useState([])
  const [selectedItems, setSelectedItems] = useState([])
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(moment().format('YYYY-MM-DD'))
  const [pageNumHistories, setPageNumHistories] = useState(1)
  const [pageNumAnalyzed, setPageNumAnalyzed] = useState(1)
  const { error, success } = useDialog();
  const inputFileRef = useRef(null)
  const nextTokenHistoriesRef = useRef(null);
  const nextTokenAnalyzedRef = useRef(null);

  const cameraNumber = state?.cameraNumber || 1
  const oldestDate = moment().subtract(sensor.data.storageImagePeriod, 'days')
  const filterByDate = selectedDate ? {
    between: [
      moment(selectedDate).startOf('day'),
      moment(selectedDate).endOf('day')
    ]
  } : {
    ge: oldestDate.startOf('day')
  }

  useEffect(() => {
    if (displayType === DISPLAY_TYPE.CAMERA_IMAGE) {
      getListHistoriesCameraSensor()
    } else {
      getListPastFloodsImage()
    }

    return () => {
      clearHistories()
    }
  }, [sensor.id, selectedDate, displayType])

  useEffect(() => {
    if (sensor.data.imageAnalysisFeature) {
      getAnalyzedHistoriesCameraSensor()
    }
    return () => {
      clearAnalyzedHistories()
    }
  }, [sensor.id])


  const getListHistoriesCameraSensor = async () => {
    try {
      setLoading(true)
      const { success, data, nextToken } = await apiListCameraSensorHistories(`${sensor.id}_${cameraNumber}`, nextTokenHistoriesRef.current, filterByDate, HISTORY_PAGE_SIZE)
      if (success) {
        const result = data.map(item => ({
          sensorId: item.sensorId,
          key: item.keyImage,
          tx: item.tx,
          isAnalyzed: item.isAnalyzed,
          status: item.status,
        }))
        setHistories(result)
        if (nextToken) {
          setPageNumHistories((prev) => prev + 1);
        }
        nextTokenHistoriesRef.current = nextToken
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
      return {
        success: false,
      }
    }
  }

  const getAnalyzedHistoriesCameraSensor = async () => {
    const result = await apiListAnalyzedCameraSensorHistories(`${sensor.id}_${cameraNumber}`, nextTokenAnalyzedRef.current, ANALYZED_PAGE_SIZE)
    if (result.success) {
      const modifiedData = result.data?.map((data) => {
        const statusValue = handleHistoryInfo(data);
        return {
          ...data,
          statusValue,
        }
      });
      setAnalyzedHistoris(modifiedData);
      if (result.nextToken) {
        setPageNumAnalyzed((prev) => prev + 1);
      }
      nextTokenAnalyzedRef.current = result.nextToken;
    }
  }

  const getListPastFloodsImage = async () => {
    try {
      setLoading(true)
      const { data, success } = await apiListCameraImagePastFlood(sensor.id, cameraNumber)
      if (success) {
        const result = data.map(item => ({
          sensorId: null,
          key: item.key,
          tx: item.lastModified,
          isAnalyzed: 0,
        }))
        setHistories(result)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const onHistoryPageChange = async (newPage) => {
    if (
      displayType === DISPLAY_TYPE.CAMERA_IMAGE &&
      pageNumHistories === newPage &&
      nextTokenHistoriesRef.current
    ) {
      setLoading(true);
      const { success, data, nextToken } = await apiListCameraSensorHistories(`${sensor.id}_${cameraNumber}`, nextTokenHistoriesRef.current, filterByDate, HISTORY_PAGE_SIZE)
      if (success) {
        const result = data.map(item => ({
          sensorId: item.sensorId,
          key: item.keyImage,
          tx: item.tx,
          isAnalyzed: item.isAnalyzed,
          status: item.status,
        }))
        setHistories((prev) => [...prev, ...result])
        if (nextToken) {
          setPageNumHistories((prev) => prev + 1);
        }
        nextTokenHistoriesRef.current = nextToken
        setLoading(false)
      }
    }
    setCurHistoriesPage(newPage);
  }

  const onAnalyzedPageChange = async (newPage) => {
    if (pageNumAnalyzed === newPage && nextTokenAnalyzedRef.current) {
      setLoading(true);
      const result = await apiListAnalyzedCameraSensorHistories(`${sensor.id}_${cameraNumber}`, nextTokenAnalyzedRef.current, ANALYZED_PAGE_SIZE)
      if (result.success) {
        const modifiedData = result.data?.map((data) => {
          const statusValue = handleHistoryInfo(data);
          return {
            ...data,
            statusValue,
          }
        });
        setAnalyzedHistoris((prev) => [...prev, ...modifiedData]);
        if (result.nextToken) {
          setPageNumAnalyzed((prev) => prev + 1);
        }
        nextTokenAnalyzedRef.current = result.nextToken;
      }
      setLoading(false);
    }
    setCurAnalyzedPage(newPage);
  }

  const onDateChange = async (e) => {
    clearHistories()
    setSelectedDate(e.target.value)
  }

  const onChangeDisplayType = (e) => {
    clearHistories()
    setDisplayType(e.target.value)
  }

  const onSelectAll = () => {
    setSelectedItems(histories.slice((curHistoriesPage - 1) * HISTORY_PAGE_SIZE, curHistoriesPage * HISTORY_PAGE_SIZE))
  }

  const clearHistories = () => {
    setHistories([])
    setCurHistoriesPage(1)
    setPageNumHistories(1)
    setSelectedItems([])
    nextTokenHistoriesRef.current = null
  }

  const clearAnalyzedHistories = () => {
    setAnalyzedHistoris([])
    setCurAnalyzedPage(1)
    setPageNumAnalyzed(1)
    nextTokenAnalyzedRef.current = null
  }

  const handleHistoryInfo = React.useCallback((item) => {
    const messageInfo = targetGroup && targetGroup.messages && targetGroup.messages[item.status];
    const statusValue = {
      color: '#000',
      content: UNDEFINED_TEXT,
    };
    if (messageInfo && item.status >= 0) {
      statusValue.color = messageInfo.color;
      statusValue.content = messageInfo.status;
    }
    return statusValue;
  }, [sensor, targetGroup]);

  const onDownloadFiles = async () => {
    try {
      if (selectedItems.length === 0) return
      setLoading(true)
      const zip = new JSZip();
      await Promise.all(selectedItems.map(async ({ key, tx }) => {
        const { body } = await downloadData({ key }).result
        const blob = await body.blob()
        const filename = convertMomentToFileName(tx) + '.jpg'
        zip.file(filename, blob, { binary: true });
      }))
      const blobFile = await zip.generateAsync({ type: "blob" })
      saveAs(blobFile, `${sensor.name}-${selectedDate || new Date().toISOString().split('T')[0]}.zip`)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
    }
  }

  const onUploadFiles = async (e) => {
    try {
      const files = Array.from(e.target.files)
      if (files.length === 0) return
      setLoading(true)
      const results = await Promise.all(files.map(async file => {
        const res = await uploadData({
          key: `camera/${PREFIX_IMAGE[DISPLAY_TYPE.PAST_FLOODS_IMAGE]}+${sensor.id}/${cameraNumber}_${new Date().toISOString()}-${file.name}`,
          data: file,
        }).result
        return {
          sensorId: null,
          key: res.key,
          tx: res.lastModified,
          isAnalyzed: 0,
        }
      }))
      setHistories(prev => sortFileByName([...results, ...prev]))
      setLoading(false)
      success(DIALOG_MESSAGE_UPLOAD_FILE_SUCCESSFULLY);
    } catch (err) {
      setLoading(false)
      error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
    }
  }

  const onDeleteFiles = async () => {
    try {
      if (selectedItems.length === 0) return
      setLoading(true)
      const results = await Promise.all(selectedItems.map(async (item) => {
        if (item.sensorId) {
          await apiDeleteCameraSensorHistory(item.sensorId, item.tx)
        }
        return await remove({ key: item.key })
      }))
      const fileKeysDeleted = results.map(item => item.key)
      const newData = histories.filter(item => !fileKeysDeleted.includes(item.key))
      setHistories([...newData])
      setLoading(false)
      const message = displayType === DISPLAY_TYPE.CAMERA_IMAGE ? DIALOG_MESSAGE_DELETE_CAMERA_IMAGE_FILE_SUCCESSFULLY : DIALOG_MESSAGE_DELETE_CAMERA_PAST_FLOOD_FILE_SUCCESSFULLY
      success(message);
    } catch (err) {
      setLoading(false)
      error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
    }
  }

  if (displayType === DISPLAY_TYPE.CAMERA_TRAFFIC_VOLUME_CHART) {
    return (
      <div className='sensor_detail_view_camera_container'>
        <select className='sensor_detail_view_camera_select_display_type' value={displayType} onChange={onChangeDisplayType}>
          <option value={DISPLAY_TYPE.CAMERA_IMAGE}>最近の様子</option>
          <option value={DISPLAY_TYPE.PAST_FLOODS_IMAGE}>過去の登録時</option>
          <option value={DISPLAY_TYPE.CAMERA_TRAFFIC_VOLUME_CHART}>交通量カウント</option>
        </select>
        <CameraTrafficVolumeChart sensor={sensor} />
      </div>
    )
  }

  return (
    <div className='sensor_detail_view_camera_container'>
      <select className='sensor_detail_view_camera_select_display_type' value={displayType} onChange={onChangeDisplayType}>
        <option value={DISPLAY_TYPE.CAMERA_IMAGE}>最近の様子</option>
        <option value={DISPLAY_TYPE.PAST_FLOODS_IMAGE}>過去の登録時</option>
        {sensor.data.trafficVolumeFeature && <option value={DISPLAY_TYPE.CAMERA_TRAFFIC_VOLUME_CHART}>交通量カウント</option>}
      </select>
      <div className="sensor_detail_view_camera_header">
        <div className='sensor_detail_view_camera_row'>
          <div className="sensor_detail_view_camera_header_btn_group">
            <button className='sensor_detail_view_camera_header_btn' onClick={onSelectAll}>
              <span>全選択</span>
            </button>
            <button className='sensor_detail_view_camera_header_btn btn_remove_all' onClick={() => setSelectedItems([])}>
              <span>全解除</span>
            </button>
            <button className='sensor_detail_view_camera_header_btn' onClick={onDeleteFiles}>
              <span>削除</span>
            </button>
            {displayType === DISPLAY_TYPE.PAST_FLOODS_IMAGE ? (
              <>
                <button className='sensor_detail_view_camera_header_btn' onClick={() => inputFileRef.current.click()}>
                  <span>アップロード</span>
                </button>
                <input
                  ref={inputFileRef}
                  onChange={onUploadFiles}
                  onClick={(event) => {
                    event.target.value = null
                  }}
                  type='file'
                  multiple
                  style={{ display: 'none' }}
                />
              </>
            ) : (
              <>
                <button className='sensor_detail_view_camera_header_btn' onClick={onDownloadFiles}>
                  <span>ダウンロード</span>
                </button>
                <input
                  type='date'
                  className='sensor_detail_view_camera_header_date_picker'
                  value={selectedDate}
                  min={moment().subtract(sensor.data.storageImagePeriod, 'days').format('YYYY-MM-DD')}
                  max={moment().format('YYYY-MM-DD')}
                  onChange={onDateChange}
                />
                <div>画像保存期間: {sensor.data.storageImagePeriod}日</div>
              </>
            )}
          </div>
          <Pagination
            pageNum={pageNumHistories}
            curPage={curHistoriesPage}
            itemNumPerPage={HISTORY_PAGE_SIZE}
            total={histories.length}
            onPageChange={onHistoryPageChange}
            isNew
          />
        </div>
      </div>
      <div className="sensor_detail_view_camera_list">
        {histories.slice((curHistoriesPage - 1) * HISTORY_PAGE_SIZE, curHistoriesPage * HISTORY_PAGE_SIZE).map((item, i) => (
          <HistoryItem
            key={item.key}
            historyItem={item}
            label={displayType === DISPLAY_TYPE.CAMERA_IMAGE ? convertMomentFormat(item.tx) : null}
            status={sensor.data.imageAnalysisFeature && item.isAnalyzed ?
              {
                color: handleHistoryInfo(item).color,
                content: handleHistoryInfo(item).content,
              }
              : null}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
          />
        ))}
      </div>
      {sensor.data.imageAnalysisFeature && displayType === DISPLAY_TYPE.CAMERA_IMAGE && <div className='sensor_detail_view_history_list_container'>
        <SensorHistoryList
          pageNum={pageNumAnalyzed}
          sensor={sensor}
          sensorHistories={analyzedHistories}
          curPage={curAnalyzedPage}
          onPageChange={onAnalyzedPageChange}
          itemNumPerPage={ITEM_NUM_PER_PAGE}
          isNew
        />
      </div>}
      {loading ? <FanLoadingIcon size={80} /> : null}
    </div >
  )
}

SensorDetailViewCamera.propTypes = propTypes


function HistoryItem({ historyItem, label, status, selectedItems, setSelectedItems }) {
  const onCheck = () => {
    setSelectedItems(prev => {
      if (prev.some(item => item.key === historyItem.key)) {
        return prev.filter(item => item.key !== historyItem.key)
      }
      return [...prev, historyItem]
    })
  }

  return (
    <div className='sensor_detail_view_camera_item'>
      <SensorCameraImage keyImage={historyItem.key} label={label} />
      <input onChange={onCheck} checked={selectedItems.some(item => item.key === historyItem.key)} type='checkbox' className='sensor_detail_camera_item_checkbox' />
      {status && <div className='sensor_detail_view_camera_item_status' style={{ backgroundColor: status.color }}>{status.content}</div>}
    </div>
  )
}
